// Lets a detail screen tell useLocale's switcher exactly where each locale's
// version of *this* record lives, for content whose URL isn't a simple
// `/xx` prefix swap. Articles are the first case: each language is a
// separate Sanity document with its own localized slug (see
// docs/article-i18n-hreflang-findings.md). Absent this context, useLocale
// falls back to swapping the `[lang]` segment in place, which is correct for
// events/tours (locale-agnostic ids/slugs) but wrong for articles.

import { createContext, useContext } from 'react';
import type { Href } from 'expo-router';

import type { Locale } from './locales';

export type LocaleLinks = Partial<Record<Locale, Href>>;

const LocaleLinksContext = createContext<LocaleLinks | null>(null);

export const LocaleLinksProvider = LocaleLinksContext.Provider;

export function useLocaleLinks(): LocaleLinks | null {
  return useContext(LocaleLinksContext);
}
